<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'600px'"
    :appendToBody="true"
    :modalAppendToBody="true"
    :offsetTop="'10vh'"
    :classDialog="'dialog-bhanh-doc-out'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div class="padding-bottom-10">
        <h3 class="dialogTitle">{{ dialogTitle }}</h3>

        <div class="select-Unit-BanHanh">
          <!-- department-tree -->
          <div class="content">
            <el-row :gutter="18">
              <el-col
                :span="12"
                class="fix__top"
              >
                <el-input
                  class="style-fullWidth searchBox"
                  v-model="search"
                  size="medium"
                  placeholder="Nhập tên đơn vị để tìm kiếm"
                  prefix-icon="el-icon-search"
                  @keydown.enter.exact.native="searchTree"
                ></el-input>
              </el-col>
            </el-row>

            <VuePerfectScrollbar
              class="scroll-scope listCompanies"
              :settings="settings"
            >
              <el-tree
                class="filter-tree"
                :data="departmentTree"
                default-expand-all
                ref="departmentTree"
                :filter-node-method="filterDepartmentTreeNode"
              >
                <span
                  class="custom-tree-node tree_unit between"
                  slot-scope="{ node, data }"
                >

                  <span v-if="data.nodeType == DEPARTMENT_TREE.NODE_TYPE.DEPT">
                    <el-checkbox
                      v-if="isAllowCheck(data.department)"
                      @click.native.stop="() => true"
                      @change="nodeCheckedChange(data)"
                      v-model="data.checked"
                    ></el-checkbox>
                    <span>&nbsp;{{ data.department ? data.department.deptName : null }}</span>
                  </span>

                  <span v-else-if="[DEPARTMENT_TREE.NODE_TYPE.DVTT, DEPARTMENT_TREE.NODE_TYPE.PBCN].indexOf(data.nodeType) != -1">
                    <span>&nbsp;{{ data.nodeType == DEPARTMENT_TREE.NODE_TYPE.DVTT ? "Đơn vị trực thuộc" : "Phòng ban chức năng"}}</span>
                  </span>
                </span>
              </el-tree>
            </VuePerfectScrollbar>

          </div>
          <!-- department-tree:end -->
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__left form-button__action">
        <el-button
          class="dialogBtnPrimary btn-none__border"
          @click="banHanh"
        >
          Chọn&nbsp;<i class="fas fa-arrow-circle-right font-size__small"></i>
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
  import constants from "../../constants";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import displayDepartmentTreeMixin from "../../mixins/displayDepartmentTreeMixin";
  import h from "../../services/h";
  import departmentService from "../../services/departmentService";

  export default {
    name: "selectDepartmentDialog",
    mixins: [displayDepartmentTreeMixin],
    props: ["isOpen", "multipleSelect", "title", "includeDeptIds"],
    components: {
    dialogTemplate: () => import('../common/custom-dialog.vue'),
      VuePerfectScrollbar
    },

    data() {
      return {
        settings: {maxScrollbarLength: 750},
        search: null,
        checkedNodes: [],
        lastCheckedNode: null,
        allowCheckDepartments: [],
        DEPARTMENT_TREE: constants.DEPARTMENT_TREE,
        DEPARTMENT: constants.DEPARTMENT
      };
    },
    computed: {
      deptId() {
        return this.$store.getters.userDeptRole.deptId;
      },

      dialogTitle() {
        return this.title ? this.title : "Chọn đơn vị";
      }
    },

    created() {
      this.loadDepartments().then(() => {
        this.buildAllowCheckDepartments();
        this.$nextTick(() => this.searchTree());
      });
    },

    methods: {
      isAllowCheck(department) {
        return this.allowCheckDepartments.indexOf(department) != -1;
      },

      filterDepartmentTreeNode(value, data) {
        return (
          (!value
            ? true
            : (data.department.deptName || "")
            .toUpperCase()
            .indexOf(value.toUpperCase()) !== -1) &&
          this.isAllowCheck(data.department)
        );
      },

      /**
       * chi cho phep xem duoc don vi cua van thu & cac don vi con;
       */
      buildAllowCheckDepartments() {
        this.allowCheckDepartments = departmentService.prepareChildDepartments(this.deptId, this.departments, this.includeDeptIds);
      },

      banHanh() {
        let event;
        if (this.multipleSelect) {
          event = {
            selectedDepartments: h.collect(
              this.checkedNodes,
              node => node.department
            )
          };
        } else {
          event = {
            selectedDepartment:
              this.lastCheckedNode && this.lastCheckedNode.checked
                ? this.lastCheckedNode.department
                : null
          };
        }

        this.$emit("change", event);
      },

      searchTree() {
        this.$refs.departmentTree.filter(this.search);
      },

      nodeCheckedChange(data) {
        !this.multipleSelect &&
        this.lastCheckedNode &&
        this.lastCheckedNode != data &&
        (this.lastCheckedNode.checked = false);
        this.lastCheckedNode = data;
        data.checked
          ? this.checkedNodes.push(data)
          : this.checkedNodes.splice(this.checkedNodes.indexOf(data), 1);
      }
    }
  };
</script>

<style scoped>
  .select-Unit-BanHanh .content {
    padding: 10px 15px;
    border: 1px solid #ceced2;
    border-radius: 4px;
  }

  .select-Unit-BanHanh .label {
    color: #2d3e4f;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 10px;
    margin-top: 7px;
  }

  .select-Unit-BanHanh .content .listCompanies.scroll-scope {
    margin-top: 5px;
    height: 200px;
    position: relative;
    /* margin-bottom: 10px; */
    width: 100%;
  }

  .select-Unit-BanHanh .content .listCompanies .company_item {
    margin: 10px 0;
  }

  .select-Unit-BanHanh .content .listCompanies .company_item .name {
    color: #2d3e4f;
    font-weight: 700;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 25px;
  }

  .tag_select {
    box-shadow: 0px 0.5px 1.5px rgb(0, 0, 0, 0.05);
    transition: all 0.25s;
  }

  .tag_select:hover {
    transform: translateY(2px);
    text-decoration: underline;
    transition: 0.15s;
    box-shadow: none;
  }

  .searchBox {
    /* background-color: var(--color-light-2); */
    /* border-color:transparent; */
  }
</style>



// WEBPACK FOOTER //
// src/views/book/selectDepartmentDialog.vue